import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { makeObservable } from 'mobx';

import type { FileResponseItem } from '../models.ts';
import { ImgFolder } from './Images/ImgFolder.tsx';
import { ImgFolderCloud } from './Images/ImgFolderCloud.tsx';
import { FileCardMenu } from './FileCardMenu.tsx';

type FolderTreeProps = {
  folders: FileResponseItem[];
  parentId: string | null;
  depth: number;
  activePath: Set<string>;
  currentFolderId: string | null | undefined;
  onFolderClick?: (id: string) => void;
  onDelete?: (folder: FileResponseItem) => void;
  onPermanentDelete?: (folder: FileResponseItem) => void;
  onManageExpiration?: (folder: FileResponseItem) => void;
};

@observer
class FolderTree extends Component<FolderTreeProps> {
  constructor(props: FolderTreeProps) {
    super(props);
    makeObservable(this);
  }

  render() {
    const { folders, parentId, depth, activePath, currentFolderId, onFolderClick, onDelete, onPermanentDelete, onManageExpiration } = this.props;
    const children = folders.filter(f => (f.parentFolderId ?? null) === parentId);
    if (children.length === 0) return null;
    return (
      <>
        {children.map(folder => (
          <React.Fragment key={folder.id}>
            <div
              className={`sidebar-item-row${folder.id === currentFolderId ? ' active' : activePath.has(folder.id) ? ' ancestor' : ''}`}
              style={{ paddingLeft: `${10 + depth * 14}px` }}
            >
              <a
                href="#"
                className="sidebar-item sidebar-item-link"
                onClick={(e) => { e.preventDefault(); onFolderClick?.(folder.id); }}
              >
                {folder.isSharedSpace ? <ImgFolderCloud size={20} /> : <ImgFolder size={20} />} {folder.fileName}
              </a>
              <div className="sidebar-item-menu">
                <FileCardMenu
                  file={folder}
                  onDelete={() => onDelete?.(folder)}
                  onPermanentDelete={onPermanentDelete ? () => onPermanentDelete(folder) : undefined}
                  onManageExpiration={() => onManageExpiration?.(folder)}
                />
              </div>
            </div>
            <FolderTree
              folders={folders}
              parentId={folder.id}
              depth={depth + 1}
              activePath={activePath}
              currentFolderId={currentFolderId}
              onFolderClick={onFolderClick}
              onDelete={onDelete}
              onPermanentDelete={onPermanentDelete}
              onManageExpiration={onManageExpiration}
            />
          </React.Fragment>
        ))}
      </>
    );
  }
}

export default FolderTree;
